const register = {
    title: String("Sign in"),
    welcomeMsg: String("Welcome to Agroupadvisor!"),
    credentialAsk: String("Fill in the form to create a new account"),
    mandatoryFields: String("The fields marked with (*) are mandatory."),
    passStrength: String("Password strength"),
    passLowStrength: String("Weak"),
    passMidStrength: String("Half"),
    passHighStrength: String("Strong"),
    policyAgreementPrefix: String("I agree with the"),
    policyAgreement: String("Privacy Policy"),
    createAccount: String("Create Account"),
    forgotPass: String("Forgot your password?"),
    login: String("I already have an account"),
    personalDataTitle: String("Personal information"),
    requiredFieldsMissing: String("There is some problem with mandatory fields"),
    cancelButton: String("Close"),
    username: String("Username"),
    password: String("Password"),
    email: String("Email"),
    confirmPassword: String("Confirm password"),
    firstName: String("Name"),
    lastName1: String("Surname"),
    lastName2: String("Second surname"),
    phone: String("Telephone"),
    nif: String("DNI or NIF"),
    userSearcher: String("Enter your address to automatically fill your data"),
    address: String("Address"),
    addressNum: String("Number"),
    city: String("Town"),
    province: String("Province"),
    country: String("Country"),
    region: String("Region"),
    postalCode: String("Postal Code"),
    payAccountNumber: String("IBAN"),
    registerGoogleAskAddressPlaceholder: String("Search address ..."),
    errorFieldRequired: String("This field is required"),
    errorInvalidField: String("Invalid field. This field can only contain letters, hyphen (-) and spaces."),
    errorInvalidNif: String("Invalid format. This field must contain 8 numbers plus a letter. 01234567A"),
    errorFieldNumeric: String("This field can only contain numbers"),
    errorPassConfirm: String("Passwords must be identical"),
    errorFieldEmail: String("Invalida email address."),
    errorInvalidLength: String("Minimum number of characters: {length}"),
    errorInvalidLengthRange: String("Number of characters should be between {length_min} and {length_max}"),
    errorPassStrength: String("The password must contain at least one capital letter, a lowercase, a number and a symbol"),
    errorPolicyAgreement: String("Acceptance of privacy policy is necessary."),
    userCreationSuccess: String("The account has been created correctly. Remember that the account must be activated by confirmation email."),
    userCreationFailedUsername: String("The account name has not been created, the username is already in use."),
    userCreationFailedEmail: String("The account has not been created, the email is already associated with an account."),
};

export default register;